import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ErrorBoundary from "./components/feature/ErrorBoundary";
import PreviewNavigationOverlay from "./components/feature/PreviewNavigationOverlay";
import InactivitySessionGuard from "./components/feature/InactivitySessionGuard";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <ErrorBoundary>
          <AppRoutes />
          <InactivitySessionGuard />
          <PreviewNavigationOverlay />
        </ErrorBoundary>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
